import { PlayControl, type PlayControlOptions } from "@shared/components"
import type { SkillColors, SkillName } from "./types/skillColors"
import type { SkillPlayerOptions } from "./types/skillPlayerOptions"

/**
 * Автоматический переключатель элементов Навыков
 */
export class SkillPlayer {
  private readonly stepDuration: number = 2500
  private index = 0
  private skills: NodeListOf<HTMLInputElement>
  private playControl: PlayControl
  private skillColors: SkillColors
  private autoplay: boolean = true

  /**
   * @param skills списко переключаемых элементов
   * @param controlButton кнопка управления
   * @param colors цвета выделения каждого навыка
   * @param stepDuration длительность паузы между переключениями
   */
  constructor(
    skills: NodeListOf<HTMLInputElement>,
    controlButton: SVGSVGElement,
    options: SkillPlayerOptions
  ) {
    this.skills = skills
    this.skillColors = options.skillColors
    this.stepDuration = options.stepDuration ?? this.stepDuration

    this.skills[this.index].checked = true
    this.playControl = new PlayControl(controlButton, this.stepDuration, () =>
      this.step()
    )
    this.playControl.update(this.getStepOptions())
    this.autoplay = options.autoplay ?? this.autoplay
    if (this.autoplay) this.playControl.play()
  }

  /**
   * Совершить шаг
   * @returns параметры следующего шага
   */
  private step(): PlayControlOptions {
    this.index = (this.index + 1) % this.skills.length
    this.skills[this.index].checked = true
    return this.getStepOptions()
  }

  /**
   * Создать объект с параметрами шага
   */
  private getStepOptions(): PlayControlOptions {
    const title = this.skills[this.index].dataset.title as SkillName
    return {
      stroke: this.skillColors[title]
    }
  }
}